//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bgImg from "../../../static/images/invite/login_bg@3x.png";
import { getDevice } from "../../utils/plugin_helper";
export default {
  name: "ApphiDownloadPage",
  data() {
    return {
      bgImg,
    };
  },
  methods: {
    homePage() {
      window.open(`${process.env.VUE_APP_HOME_URL}`, "_blank");
    },
    installBtnClick() {
      const device = getDevice();
      if (device === "ios") {
        window.open(
          "https://itunes.apple.com/us/app/apphi-scheduler-for-instagram/id1251406049?mt=8",
          "_blank"
        );
      } else {
        window.open("https://go.onelink.me/app/apphiwebforandroid", "_blank");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/login/Download.vue